var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.182,
    height: 19.089,
    viewBox: "0 0 21.182 19.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#78849e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.832 0.967)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.288,6v5.788H25.5",
    transform: "translate(-11.998 -5.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.374,16.077a8.682,8.682,0,1,1-2.045-9.029L23.8,11.254",
    transform: "translate(-4.505 -4.503)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.6b639f2fcc1f9b92bdb671d5bc3ed581.svg";
export { ForwardRef as ReactComponent };